export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/d1wVqvieY8BZ2u5c3UVzTc/Bel_Air_Logo.png'

export const brand = {
  name: 'Bel Air',
  descriptor: 'Luxury Apartment',
  tagline: 'Redefined Luxury. Timeless Living.',
  promise: 'Bel Air brings architecture, comfort, and refined hospitality together to make every stay feel exceptional.',
  positioning:
    'Premium short-let accommodation where thoughtful design meets exceptional comfort — more than a place to sleep.',
}

export const brandPillars = [
  {
    title: 'Structure',
    copy: 'Order, precision and the assurance of a well-considered space. Every room is planned before it is furnished.',
  },
  {
    title: 'Strength',
    copy: 'Composure, exclusivity and retreat. A private address that stays calm while the city moves around it.',
  },
  {
    title: 'Prestige',
    copy: 'Warmth, refinement and quality you can feel — across every interior, amenity and detail of your stay.',
  },
]

export const emblemStory = [
  'Our emblem fuses the letters B and A into a single architectural form. Its structured lines and balanced proportions reflect Bel Air’s commitment to premium short-let accommodation where thoughtful design meets exceptional comfort.',
  'The deliberate spaces within it evoke openness, airflow, and the freedom to feel at home — the same qualities we build into every stay.',
]
